// tslint:disable
import { style } from 'typestyle'
import * as csstips from 'csstips'

export const titleName = style({
    fontSize: 20,
    color: '#000000',
    letterSpacing: 0,
    lineHeight: '20px',
    fontWeight: 500,
    marginTop: 15,
    marginBottom: 14,
    paddingLeft: 15
})

export const SlideLectureContent = style({
    // ...csstips.flexRoot,
    "display": '-webkit-box',
    '-webkit-overflow-scrolling': 'touch',
    'overflow': 'auto',
    'paddingBottom': 15
})

export const SlideLectureContentItem = style({
    paddingLeft: 5,
    paddingRight: 5,
    cursor: 'pointer',
    $nest: {
        '&:first-child': {
            paddingLeft: 15
        },
        '&:active': {
            opacity: 0.5
        },
        '&:last-child': {
            paddingRight: 15
        }
    }
})

export const itemTitle = style({
    fontWeight: 500,
    fontSize: 13,
    color: '#333333',
    letterSpacing: 0,
    lineHeight: '20px',
    maxWidth: 135.68,
    width: '28.26vw',
    marginTop: 10,
    height: 40,
    marginBottom: 5
})

export const itemCover = style({
    position: 'relative',
    width: '28.26vw',
    height: '28.26vw',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    maxWidth: 135.68,
    maxHeight: 135.68,
    borderRadius: 8,
    backgroundPosition: 'center'
})

export const playBtn = style({
    display: 'inline-block',
    position: 'absolute',
    right: 5,
    bottom: 5,
    width: '8.5vw',
    maxWidth: 40.96
})

export const bgCover = style({
    height: '100%',
    objectFit: 'cover'
})

export const itemBottom = style({
    $nest: {
        img: {
            display: 'inline-block',
            position: 'relative',
            top: 1,
            width: 10
        },
        i: {
            fontStyle: 'normal',
            fontSize: 12,
            color: '#999999',
            lineHeight: '16px',
            marginLeft: 5
        }
    }
})

export const itemCoverWrap = style({
    position: 'relative',
    width: '28.26vw',
    height: '28.26vw',
    overflow: 'hidden',
    maxWidth: 135.68,
    maxHeight: 135.68,
    borderRadius: 8,
    $nest: {
        'img': {
            width: '100%',
            height: '100%',
            overflow: 'hidden'
        }
    }
})



// WEBPACK FOOTER //
// ./src/views/Home/components/HomeSlideLecture/HomeSlideLecture.style.ts